import IcChevronDown from "~/images/ic_chevron_down.svg";
import IcChevronUp from "~/images/ic_chevron_up.svg";
import styles from "./ScrollButton.module.css";

interface ScrollButtonProps {
  direction: "up" | "down";
  status: "default" | "disabled";
  onClick: () => void;
}

export function ScrollButton({
  direction,
  status,
  onClick,
}: ScrollButtonProps) {
  return (
    <button
      className={styles.scrollButton}
      disabled={status === "disabled"}
      type="button"
      onClick={onClick}
    >
      <img
        alt={`scroll-${direction}`}
        src={direction === "down" ? IcChevronDown : IcChevronUp}
      />
    </button>
  );
}
